import {Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {Subject} from 'rxjs';
import {AppService} from 'app/services/app.service';

export interface ITextDialogData {
	title?: string;
	contentMessage: string;
	positiveText?: String;
	negativeText?: String;
}

@Component({
    selector: 'text-dialog',
    templateUrl: 'dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextDialogComponent implements OnDestroy, OnInit {

	loading = false;
	safeContent: SafeHtml;
	protected _unsubscribeAll: Subject<void>;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<TextDialogComponent>,
		private sanitizer: DomSanitizer,
		@Inject(MAT_DIALOG_DATA) public data: ITextDialogData
	) {
		this._unsubscribeAll = new Subject();
	}

	ngOnInit(): void{
		this.safeContent = this.sanitizer.bypassSecurityTrustHtml(this.data.contentMessage || '');
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	onYesClick(): void {
		this.dialogRef.close(true);
	}

	ngOnDestroy(): void{
		// Unsubscribe from all subscriptions
		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}

}
